import{camelCase as e}from"lodash-es";const t=t=>e(t+`_id`);export{t as scopeKeyId};
//# sourceMappingURL=scope-key-id.mjs.map